import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import FetchStatus from 'common/types/FetchStatus';
import React, { useEffect, useState } from 'react';
import Loading from '_design/svg/Loading';
import { tryAutoLogin } from './auth/AuthSlice';

function AppGate({ children }: { children: React.ReactNode }) {
  const { auth } = useTypedSelector((state) => ({
    auth: state.auth,
  }));
  const [hasAttemptedAutoLogin, setAutoComplete] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const authenticating =
    auth.fetchStatus === FetchStatus.loading ||
    auth.fetchStatus === FetchStatus.none;

  const dispatch = useThunkDispatch();
  useEffect(() => {
    dispatch(tryAutoLogin()).then(() => setAutoComplete(true));
  }, [dispatch]);

  const attemptingAutoLogin = !hasAttemptedAutoLogin && authenticating;

  useEffect(() => {
    if (!attemptingAutoLogin) {
      setTimeout(() => {
        setAnimationComplete(true);
      }, 1200);
    }
  }, [attemptingAutoLogin]);

  if (!animationComplete) {
    return (
      <div>
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}
        >
          <Loading />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default AppGate;
